export const VERIFICATION_HELP_PROMPT =
  'How do I check and run the verification for my Cloudflare integration myself?';
